module.exports = __webpack_public_path__ + "img/600.f293b16c.svg";